import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '../../../../../../../../components/SearchForm/components/AirportsWidget/components/CountryList/components/Container.js';
import { Item } from '../../../../../../../../components/SearchForm/components/AirportsWidget/components/Suggestions/components/List/components/Item/index.js';
import { useExpandedSections } from '../../../../../../../../components/SearchForm/components/AirportsWidget/hooks/useExpandedSections.js';
import { Stack } from '../../../../../../../../primitives/index.js';
import { SPACING_NONE, SPACING_SMALL } from '../../../../../../../../utils/spacingLegacy.js';
export const List = ({
  data,
  isChecked,
  onCheck,
  value
}) => {
  const [expandedSections, toggleExpand] = useExpandedSections();
  return _jsx(Container, {
    spacing: SPACING_NONE,
    children: _jsx(Stack, {
      spacing: SPACING_SMALL,
      children: data.map((item, index) => _jsx(Item, {
        item: item,
        isExpanded: expandedSections[index] || false,
        value: value,
        isChecked: isChecked,
        onCheck: onCheck,
        toggleExpand: toggleExpand(index)
      }, index))
    })
  });
};